import { useAsyncData, useRequestURL } from '#imports'

import type { ArticleCard } from '@backmarket/nuxt-layer-cms/ArticleCard/ArticleCard.types'
import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'
import { insertIf } from '@backmarket/utils/collection/insertIf'
import { isBrowser } from '@backmarket/utils/env/isBrowser'

export function useArticles() {
  const { pathname } = useRequestURL()
  const $httpFetch = useHttpFetch()

  return useAsyncData(
    `plp-articles-${pathname}`,
    () =>
      $httpFetch('/internal-links/v1/cards', {
        query: {
          source_url: pathname,
        },
        ...insertIf(!isBrowser(), { timeout: 500 }),
      }),
    {
      transform: (data) =>
        data?.linkLists
          .find((item) => item.listId === 'plp_related_articles')
          ?.links.map((item) => ({
            title: item.title,
            text: item.description,
            id: item.link.href,
            imageSrc: item.image.src,
            link: { href: item.link.relativeHref },
            category: item.tagline,
            ...(item.image.alt ? { imageAlt: item.image.alt } : {}),
          }))
          .filter(
            (item): item is ArticleCard =>
              item.imageSrc !== null &&
              item.title !== null &&
              item.text !== null,
          ) ?? [],
      default: () => [],
    },
  )
}
